import { motion } from "framer-motion";
import { HelpCircle, LayoutGrid, Check } from "lucide-react";
import { ABOUT } from "../data/content";

export const About = () => {
  return (
    <section id="nosotros" data-testid="about-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <img
              src={ABOUT.image}
              alt="Universidad Politécnica de Pachuca"
              data-testid="about-image"
              className="w-full h-[460px] lg:h-[560px] object-cover rounded-sm lg:-mt-8"
            />
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#5B3E96]/10 -z-10 hidden md:block" />
          </motion.div>

          <div>
            <p className="text-xs uppercase tracking-overline text-[#5B3E96] font-semibold mb-5">
              {ABOUT.overline}
            </p>
            <h2 className="font-serif-display text-3xl md:text-5xl font-semibold text-[#2D1B4E] tracking-tight leading-[1.1]">
              {ABOUT.title}
            </h2>
            {ABOUT.items.map((item, i) => (
              <div key={i} className="flex items-start gap-3 mt-4" data-testid={`about-item-${i}`}>
                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#5B3E96]/10 shrink-0 mt-0.5">
                  <Check strokeWidth={2} className="w-4 h-4 text-[#5B3E96]" />
                </span>
                <p className="text-base text-[#1A1523] leading-relaxed">{item}</p>
              </div>
            ))}

            <div className="grid sm:grid-cols-2 gap-6 mt-10">
              <div
                data-testid="mission-card"
                className="border border-[#E8E4EE] p-6 rounded-sm"
              >
                <HelpCircle strokeWidth={1.5} className="w-7 h-7 text-[#5B3E96]" />
                <h3 className="font-serif-display text-2xl font-semibold text-[#2D1B4E] mt-4">
                  {ABOUT.card1Title}
                </h3>
                <p className="text-sm text-[#5F5670] mt-2 leading-relaxed">
                  {ABOUT.card1Text}
                </p>
              </div>
              <div
                data-testid="vision-card"
                className="bg-[#2D1B4E] p-6 rounded-sm"
              >
                <LayoutGrid strokeWidth={1.5} className="w-7 h-7 text-[#C7B8E6]" />
                <h3 className="font-serif-display text-2xl font-semibold text-white mt-4">
                  {ABOUT.card2Title}
                </h3>
                <p className="text-sm text-white/70 mt-2 leading-relaxed">
                  {ABOUT.card2Text}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
